export const howItsWorks = {
  icons: {
    color: null
  }
};